import { createContext, useContext } from 'react';

import { OptionContextProps } from '../types';

export const OptionContext = createContext<OptionContextProps<any>>({
  index: 0,
  label: 'No Options',
  option: {},
});

export const useOptionContext = <T extends Record<string, any>>() =>
  useContext(OptionContext) as OptionContextProps<T>;
